module.exports = __webpack_public_path__ + "static/logo-964a2f6fc2016fa61290a28d583d4e8d.png";